import { Component, OnInit, ViewChild } from '@angular/core';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter, MdDialog, MdDialogConfig } from '@angular/material';
import { FormControl } from '@angular/forms';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_MOTOR } from '../../../services/search-service';
import { CuentasService } from '../../../services/cuentas-service';
import { 
  AgendaService, 
  DAILY_RECURRENCE, 
  ABSOLUTE_MONTHLY_RECURRENCE, 
  RELATIVE_MONTHLY_RECURRENCE, 
  RELATIVE_YEARLY_RECURRENCE,
  WEEKLY_RECURRENCE,
  ABSOLUTE_YEARLY_RECURRENCE } from '../../../services/agenda-service';
import { Observable } from 'rxjs/Observable';
import { MotorAutocompleteComponent } from '../../../components/common/autocomplete';
import { CuentaEtiquetaAutocompleteComponent } from '../../../components/common/autocomplete';
import { ColaboradorAutocompleteComponent } from '../../../components/common/autocomplete';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { dateToUnixTime, parseDate } from '../../../utils/DateHelper';

import { RepetirSubDialogComponent } from './repetir-subdialog.component';

@Component({
  selector: 'app-new-consigna-dialog',
  templateUrl: './new-consigna-dialog.component.html',
  styleUrls: ['./new-consigna-dialog.component.scss']
})
export class NewConsignaDialogComponent implements OnInit {

  public draft: boolean = false;

  public title: string;
  public positiveText: string;
  public negativeText: string;
  public otherOptionsText: string;

  /** Edit mode */
  public consigna;

  private advancedOptions: boolean = false;

  // Form data
  private consignaTitle: string;
  private sendEmailToAccounts: boolean = false;
  private customNotification: boolean = false;
  private allDay = false;
  public startDate;
  public endDate;
  public horasVencimiento = '1';
  private descripcion: string;
  public isEdit: boolean;
  private minDate = moment(this.startDate).toDate();


  public typeNotif: number = 1;  // 1: hours, 24: days, 168: weeks

  public maxNotif: number = 24;
  public minNotif: number = 1;

  @ViewChild('startDatePicker') startDatePicker;
  @ViewChild('endDatePicker') endDatePicker;
  @ViewChild('startTimeSelect') startTimeSelect;

  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;
  @ViewChild(CuentaEtiquetaAutocompleteComponent) cuentaEtiquetaAutocompleteComponent;
  @ViewChild(MotorAutocompleteComponent) motorAutocompleteComponent;

  public timePickerOptions = {};
  public datePickerOptions = {};

  allDayTimes = [ '00:00', '23:59' ];

  public repeatConsignaValue: string = 'NEVER';
  public repeatConsignaOptions = [];
  public repeatStartDate;
  public repeatEndDate;
  public repeatModel: any = {};
  public repeatPosition;
  public hideRepeatEndDate: boolean = true;
  public repeatModelIncompleteError: boolean = false;

  @ViewChild('repeatStartDatePicker') repeatStartDatePicker;
  @ViewChild('repeatEndDatePicker') repeatEndDatePicker;

  constructor(public dialogRef: MdDialogRef<NewConsignaDialogComponent>,
              public cuentasService: CuentasService,
              public agendaService: AgendaService,
              private dateAdapter: DateAdapter<Date>,
              private searchService: SearchService,
              private dialog: MdDialog) {

    // Set datepicker locale to the one expected so it doesn't swap the day and
    // month when opening the calendar again, we hide the associated input anyways
    this.dateAdapter.setLocale('en-us');
  }

  setupEditConsigna(){
    console.log(this.consigna);

    this.consignaTitle = this.consigna.Title;

    if (this.consigna.StartDate === 0 && this.consigna.EndDate === 0) {
      this.draft = true;
      this.startDate = moment().startOf('hour').add(1, 'hours').toDate();
      this.endDate = moment().startOf('hour').add(2, 'hours').toDate();
    } else {
      this.startDate = parseDate(this.consigna.StartDate);
      this.endDate = parseDate(this.consigna.EndDate);
    }

    this.descripcion = this.consigna.Descripcion;

    let clientesArray = [];
    let colaboradoresArray = [];
    let motoresArray = [];
    let etiquetasArray = [];
    let contactosArray = [];

    if (this.consigna.Cliente){
      clientesArray.push(this.consigna.Cliente);
      contactosArray = this.consigna.Cliente.Contacts || [];
    }

    colaboradoresArray = colaboradoresArray.concat(this.consigna.ConsignaResponsables);
    motoresArray = motoresArray.concat(this.consigna.ConsignaMotor);

    console.log(colaboradoresArray);

    this.colaboradorAutocompleteComponent.selectedColaboradores = colaboradoresArray;
    this.cuentaEtiquetaAutocompleteComponent.selectedCuentas = clientesArray;
    //this.motorAutocompleteComponent.selectedMotores = motoresArray;
    this.cuentaEtiquetaAutocompleteComponent.selectedEtiquetas = etiquetasArray;
    this.cuentaEtiquetaAutocompleteComponent.selectedContactos = contactosArray;
  }

  ngOnInit() {
    console.log(this.startDate);
    
    if (this.consigna){
      this.setupEditConsigna();
      this.isEdit = true;
      this.advancedOptions = this.consigna.StartDate !== 0 && this.consigna.EndDate !== 0;
    }
    if (!this.consigna) {
      if (this.startDate && this.startDate.getTime() !== moment().startOf('day').toDate().getTime()) {
        this.startDate = moment(this.startDate).hours(12).minutes(0).toDate();
        this.endDate = moment(this.startDate).hours(13).minutes(0).toDate();
      } else {
        this.startDate = moment().startOf('hour').add(1, 'hours').toDate();
        this.endDate = moment().startOf('hour').add(2, 'hours').toDate();
      }

      this.repeatStartDate = moment(this.startDate).startOf('hour').add(1, 'hours').toDate();
      this.repeatEndDate = moment(this.startDate).startOf('hour').add(2, 'hours').toDate();
      
      this.isEdit = false;
    }

    this.setupDateTimePickerOptions();
    this.setupRepeatConsignaOptions();
  }

  setupDateTimePickerOptions() {
    this.timePickerOptions = {
      icon: '',
      icons: {
        up: 'zmdi zmdi-chevron-up',
        down: 'zmdi zmdi-chevron-down'
      },
      placeholder: 'Hora',
      autoclose: true,
      showMeridian: false
    };

    this.datePickerOptions = {
      placeholder: 'Fecha',
      format: 'dd/mm/yyyy',
      autoclose: true,
      todayHighlight: true,
      language: 'es'
    };
  }

  setupRepeatConsignaOptions() {
    const current = moment(this.repeatStartDate);
    const dayOrders = ['primer', 'segundo', 'tercer', 'cuarto', 'último'];
    this.repeatPosition = Math.floor((Number(current.format('D'))-1) / 7);
    this.repeatConsignaOptions = [{
        name: 'Nunca',
        value: 'NEVER'
      },{
        name: 'Todos los días',
        value: 'EVERY_DAY'
      },{
        name: current.format('[Cada] dddd'),
        value: 'WEEKLY'
      },{
        name: 'Cada día laborable',
        value: 'WORKDAY'
      },{
        name: current.format('[Día] D [de cada mes]'),
        value: 'MONTHLY'
      },{
        name: 'Cada '+dayOrders[this.repeatPosition]+current.format(' dddd'),
        value: 'MONTHLY2'
      },{
        name: current.format('[Cada] D [de] MMMM'),
        value: 'MONTHLY3'
      },{
        name: 'Otros...',
        value: 'OTHERS'
    }];
  }

  repeatStartDateChanged(e) {
    const dayOrders = ['FIRST', 'SECOND', 'THIRD', 'FOURTH', 'LAST'];

    const current = moment(this.repeatStartDate);
    this.setupRepeatConsignaOptions();

    // actualizar el modelo que se usa en el popup "otros" también
    if (this.repeatModel.mode === 'MONTHLY') {
      this.repeatModel.interval1 = String(current.date());
    } else if (this.repeatModel.mode === 'YEARLY') {
      this.repeatModel.interval1 = String(current.date());
      this.repeatModel.month = current.month();
    } else if (this.repeatModel.mode === 'YEARLY2') {
      this.repeatModel.month = current.month();
      this.repeatModel.day = current.day();
      this.repeatModel.position = dayOrders[Math.floor((Number(current.format('D'))-1) / 7)];
    }
    
  }

  updateRepetirDates(e) {
    //this.repeatStartDate = new Date();
    switch (e.value) {
      case 'EVERY_DAY':
        this.repeatEndDate = moment(this.repeatStartDate).add(3, 'month').toDate();
        break;
      case 'WEEKLY': 
      case 'WORKDAY':
        this.repeatEndDate = moment(this.repeatStartDate).add(5, 'month').toDate();
        break;
      case 'MONTHLY':
      case 'MONTHLY2':
        this.repeatEndDate = moment(this.repeatStartDate).add(1, 'year').toDate();
        break;
      case 'MONTHLY3':
        this.repeatEndDate = moment(this.repeatStartDate).add(2, 'year').toDate();
        break;
      default:
        this.repeatEndDate = moment(this.repeatStartDate).add(1, 'year').toDate();
    }
  }

  closeRepetirOptions() {
    if (this.repeatConsignaValue === 'OTHERS') {
      let dialogRef: MdDialogRef<RepetirSubDialogComponent>;
      
      let config = new MdDialogConfig();
      config.width = '500px';
      
      dialogRef = this.dialog.open(RepetirSubDialogComponent, config);
      dialogRef.componentInstance.model = this.repeatModel;
      dialogRef.afterClosed().subscribe(d => {
        if (d && d.mode) {
          this.repeatModel = d;

          // update start date
          this.updateStartDateOnCloseOthers();
        }
      });
    }
  }

  updateStartDateOnCloseOthers() {
    const d = this.repeatModel;
    const dayOrders = ['FIRST', 'SECOND', 'THIRD', 'FOURTH', 'LAST'];

    if (d.mode === 'MONTHLY') {
      this.repeatStartDate = moment(this.repeatStartDate).date(Number(d.interval1));
      if (this.repeatStartDate.isBefore(moment())) {
        this.repeatStartDate.add(1, 'month');
      }
      this.repeatStartDate = this.repeatStartDate.toDate();
    } else if (d.mode === 'YEARLY') {
      this.repeatStartDate = moment(this.repeatStartDate).date(Number(d.interval1)).month(d.month);
      if (this.repeatStartDate.isBefore(moment())) {
        this.repeatStartDate.add(1, 'year');
      }
      this.repeatStartDate = this.repeatStartDate.toDate();
    } else if (d.mode === 'YEARLY2') {
      let tmp = moment(this.repeatStartDate).month(d.month).startOf('month');
      const add = (d.day-tmp.day() + 7*(d.day-tmp.day() < 0 ? 1 : 0)) + 7*dayOrders.indexOf(d.position);
      tmp.add(add, 'days');
      if (d.position === 'LAST' && tmp.month() !== d.month) {
        tmp.add(-7, 'days');
      }
      this.repeatStartDate = tmp.toDate();
    } else if (d.mode === 'WEEKLY2') {
      let tmp = moment(this.repeatStartDate).startOf('month');
      const add = (d.day-tmp.day() + 7*(d.day-tmp.day() < 0 ? 1 : 0)) + 7*dayOrders.indexOf(d.position);
      tmp.add(add, 'days');
      if (d.position === 'LAST' && tmp.month() !== moment(this.repeatStartDate).month()) {
        tmp.add(-7, 'days');
      }
      this.repeatStartDate = tmp.toDate();
    }
    this.setupRepeatConsignaOptions();
  }

  hideRepeatEndDateClick() {
    this.hideRepeatEndDate = true;

    // to avoid any validation issues, we're not gonna use it if we hide it anyways
    if (moment(this.repeatStartDate).isAfter(moment(this.repeatEndDate))) {
      this.repeatEndDate = moment(this.repeatStartDate).add(6, 'months').toDate();
    }
  }

  ngAfterViewInit() {
    this.checkInitialFormData();
  }

  searchResponsables(term: string, type: number){
    return this.searchService.searchAutocomplete(term, type)
          .map( value => {
            return value;
          });
  }

  checkInitialFormData(){


    if (this.cuentaEtiquetaAutocompleteComponent.cuentas.length > 0){
      this.cuentaEtiquetaAutocompleteComponent.cuentas.map( value => this.cuentaEtiquetaAutocompleteComponent.selectedCuentas.push(value));
    }

    if (this.colaboradorAutocompleteComponent.colaboradores.length > 0){
      this.colaboradorAutocompleteComponent.colaboradores.map( value => this.colaboradorAutocompleteComponent.selectedColaboradores.push(value));
    }

    if (this.cuentaEtiquetaAutocompleteComponent.selectedCuentas.length + 
        this.cuentaEtiquetaAutocompleteComponent.selectedContactos.length + 
        this.colaboradorAutocompleteComponent.colaboradores.length > 0)
    {
      this.advancedOptions = true;
    }
  }

  showStartDatePicker(){
    this.startDatePicker.open();
  }

  showEndDatePicker(){
    this.endDatePicker.open();
  }

  showRepeatStartDatePicker(){
    this.repeatStartDatePicker.open();
  }

  showRepeatEndDatePicker(){
    this.repeatEndDatePicker.open();
  }

  selectedStartDate(e) {
    if (e > this.endDate) {
      this.endDate = new Date(e);
    }
  }
  selectedEndDate(e) {
    if (e < this.startDate) {
      this.startDate = new Date(e);
    }
  }

  onWholeDayToggle() {
    // help the user a little bit in case they enabled the whole day option and
    // the end date is set before the start date
    if (this.allDay &&
        moment(this.startDate).startOf('day').toDate() > moment(this.endDate).startOf('day').toDate())
    {
      this.endDate = this.startDate;
    }
  }

  onSubmit(){

    let selectedMotoresArray = this.consigna ? this.consigna.ConsignaMotor : [];  /*Array.from(this.motorAutocompleteComponent.selectedMotores).map( item => ({
      Id: (item as any).Id
    }));*/

    let selectedColaboradoresArray = Array.from(this.colaboradorAutocompleteComponent.selectedColaboradores).map( item => ({
      UserId: (item as any).UserId
    }));

    let selectedCuentasArray: any = Array.from(this.cuentaEtiquetaAutocompleteComponent.selectedCuentas).map( item => ({
      Id: (item as any).Id
    }));

    this.cuentaEtiquetaAutocompleteComponent.selectedContactos.forEach(contacto => {
      let tmp = selectedCuentasArray.find(c => c.Id === contacto.ClienteId);
      if (tmp) {
        tmp.Contacts = tmp.Contacts || [];
        tmp.Contacts.push({
          ClientContactId: contacto.ClientContactId
        });
      } else {
        selectedCuentasArray.push({
          Id: contacto.ClienteId,
          Contacts: [{ClientContactId: contacto.ClientContactId}]
        });
      }
    });

    let selectedEtiquetasArray = Array.from(this.cuentaEtiquetaAutocompleteComponent.selectedEtiquetas).map( item => ({
      Id: (item as any).Id
    }));

    let startDate = this.draft ? null : this.startDate;
    let endDate = this.draft ? null : this.endDate;
    if (this.allDay && !this.draft) {
      startDate = moment(this.startDate).startOf('day').toDate();
      endDate = moment(this.endDate).endOf('day').toDate();
    }

    let recurrence = this.getRecurrenceObject();

    this.repeatModelIncompleteError = !this.validateRepeatOthers(recurrence);

    if (this.repeatModelIncompleteError) {
      return;
    }

    if (this.consigna) {
      this.agendaService.editConsigna(
        this.consigna.Id,
        this.consignaTitle,
        startDate,
        endDate,
        selectedMotoresArray,
        selectedColaboradoresArray,
        selectedCuentasArray,
        selectedEtiquetasArray,
        this.customNotification,
        Number(this.horasVencimiento) * this.typeNotif,
        this.sendEmailToAccounts,
        this.descripcion
      ).subscribe(
        data => {
          this.dialogRef.close();
        });
    } else {
      this.agendaService.addConsigna(
        this.consignaTitle,
        startDate,
        endDate,
        selectedMotoresArray,
        selectedColaboradoresArray,
        selectedCuentasArray,
        selectedEtiquetasArray,
        this.customNotification,
        Number(this.horasVencimiento) * this.typeNotif,
        this.sendEmailToAccounts,
        this.descripcion,
        recurrence
      ).subscribe(
        data => {
          this.dialogRef.close(data);
        });
    }
  }

  getRecurrenceObject() {
    const dayOrders = ['FIRST', 'SECOND', 'THIRD', 'FOURTH', 'LAST'];

    let recurrence:any = {
      StartDate: Number(moment(this.repeatStartDate).startOf('day').format('X')),
      EndDate: this.hideRepeatEndDate ? null : Number(moment(this.repeatEndDate).endOf('day').format('X'))
    };
    switch (this.repeatConsignaValue) {
      case 'NEVER': 
        recurrence = {};
        break;
      case 'EVERY_DAY':
        recurrence.Type = DAILY_RECURRENCE;
        recurrence.Interval = 1;
        break;
      case 'WEEKLY':
        recurrence.Type = WEEKLY_RECURRENCE;
        recurrence.Interval = 1;
        recurrence.DaysOfWeek = [Number(moment(this.repeatStartDate).format('d'))];
        break;
      case 'WORKDAY':
        recurrence.Type = WEEKLY_RECURRENCE;
        recurrence.Interval = 1;
        recurrence.DaysOfWeek = [1,2,3,4,5];
        break;
      case 'MONTHLY':
        recurrence.Type = ABSOLUTE_MONTHLY_RECURRENCE;
        recurrence.Interval = 1;
        break;
      case 'MONTHLY2':
        recurrence.Type = RELATIVE_MONTHLY_RECURRENCE;
        recurrence.DayOfWeekIndex = this.repeatPosition;
        recurrence.Interval = 1;
        recurrence.DaysOfWeek = [Number(moment(this.repeatStartDate).format('d'))];
        break;
      case 'MONTHLY3':
        recurrence.Type = ABSOLUTE_YEARLY_RECURRENCE;
        break;
      case 'OTHERS':
        if (this.repeatModel.mode === 'DAILY') {
          recurrence.Type = DAILY_RECURRENCE;
          recurrence.Interval = Number(this.repeatModel.interval1);
        } else if (this.repeatModel.mode === 'WEEKLY') {
          recurrence.Type = WEEKLY_RECURRENCE;
          recurrence.Interval = Number(this.repeatModel.interval1);
          recurrence.DaysOfWeek = this.repeatModel.shortweekdays.filter(d => d.model).map(d => d.value);
        } else if (this.repeatModel.mode === 'MONTHLY') {
          recurrence.Type = ABSOLUTE_MONTHLY_RECURRENCE;
          recurrence.Interval = Number(this.repeatModel.interval2);
        } else if (this.repeatModel.mode === 'WEEKLY2') {
          recurrence.Type = RELATIVE_MONTHLY_RECURRENCE;
          recurrence.DayOfWeekIndex = dayOrders.indexOf(this.repeatModel.position);
          recurrence.DaysOfWeek = [this.repeatModel.day];
          recurrence.Interval = Number(this.repeatModel.interval1);
        } else if (this.repeatModel.mode === 'YEARLY') {
          recurrence.Type = ABSOLUTE_YEARLY_RECURRENCE;
        } else if (this.repeatModel.mode === 'YEARLY2') {
          recurrence.Type = RELATIVE_YEARLY_RECURRENCE;
          recurrence.DayOfWeekIndex = dayOrders.indexOf(this.repeatModel.position);
          recurrence.DaysOfWeek = [this.repeatModel.day];
        }
        break;
    }

    return recurrence;
  }

  validateRepeatOthers(recurrence) {
    let res = true;

    if (this.repeatConsignaValue === 'OTHERS') {
      switch (this.repeatModel.mode) {
        case 'DAILY':
          res = !isNaN(recurrence.Interval)
          break;
        case 'WEEKLY':
          res = !isNaN(recurrence.Interval) && recurrence.DaysOfWeek.length > 0;
          break;
        case 'MONTHLY':
          res = !isNaN(recurrence.Interval);
          break;
        case 'WEEKLY2':
          res = !isNaN(recurrence.Interval) && !isNaN(recurrence.DaysOfWeek[0]) && recurrence.DayOfWeekIndex >= 0;
          break;
        case 'YEARLY':
          res = true;
          break;
        case 'YEARLY2':
          res = !isNaN(recurrence.DaysOfWeek[0]) && recurrence.DayOfWeekIndex >= 0;
          break;
        default:
          res = false;
      }
    }

    return res;
  }

  advancedOptionsChanged(){
    this.advancedOptions = !this.advancedOptions;
  }

  closeDialog(){
    this.dialogRef.close();
  }

  updateMaxNotif(e) {
    this.maxNotif = e.value === 1 ? 24 : (e.value === 24 ? 30 : 16);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agenda/new-consigna-dialog/new-consigna-dialog.component.ts